module.exports = __webpack_public_path__ + "img/nme-1.0ce1cd52.png";